if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.submitButton.classList.remove("temp__button--disabled");

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if ( typeof checkSelectedOption === 'function' ) {
        checkSelectedOption();
      }
      if(this.form.querySelector('.js-cart-notification-btn')){
        if(document.querySelector('#cart-notification')) document.querySelector('#cart-notification').scrollTo({ top: 0, behavior: 'smooth' });
      }
      if (!!this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if(this.submitButton && this.submitButton.classList.contains("js-variant-bundle-atc")) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      if(!!this.querySelector('.loading-overlay__spinner')) {
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!formData.get("selling_plan")) {
       const selectedSellingPlanEl = document.querySelector('.yotpo-selected [name="selling_plan"]');
       const sellingPlanId = selectedSellingPlanEl && selectedSellingPlanEl.value ? selectedSellingPlanEl.value : '';
       formData.append("selling_plan", sellingPlanId);
      }
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      let varId = formData.get("id");
      let quantity = formData.get("quantity");

      // Fix duplicate quantity in FormData — keep the maximum one
      let quantities = [];
      for (let [key, value] of formData.entries()) {
        if (key === "quantity") {
          quantities.push(parseInt(value, 10));
        }
      }

      if (quantities.length > 1) {
        const maxQuantity = Math.max(...quantities);
        // Remove all quantity entries
        formData.delete("quantity");
        // Append only the highest quantity value
        formData.append("quantity", maxQuantity);
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {

          var freeGiftElement = document.getElementById('free_gift');
          if (freeGiftElement && freeGiftElement.getAttribute('data-checkeligibility') === 'true') {
            window.getCart();
          }
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            // console.log(response)
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            let showDrawer = document.body.dataset.showDrawer !== 'false';
            if (document.body.dataset.cartType === 'drawer' && !showDrawer) {
              // stay on page, don't redirect, don't open drawer
              return;
            }
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response, varId, quantity) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            let hideCartNotification = false;
            let closestQuickOrderProductsItem = this.form.closest('.quick__order--products-item');
            if(closestQuickOrderProductsItem){
              hideCartNotification = true;
            }
            this.cart.renderContents(response, varId, quantity, hideCartNotification);
          }
          //FreeShipping AnnouncementBar Function
            window.GetCart();
          //FreeShipping AnnouncementBar Function

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if ( typeof productAddedToCart === 'function' ) {
            productAddedToCart();
          }
          if ( typeof addFilesAsProperties === 'function' ) {
            addFilesAsProperties();
          }
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if(this.querySelector('.loading-overlay__spinner')){
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }

          
          // Check for specific sections
          let closestQuickOrderProductsItem = this.form.closest('.quick__order--products-item');
          
          if (closestQuickOrderProductsItem) {
            const originalText = this.submitButton.querySelector("span").textContent;
            // Change the button text
            this.submitButton.querySelector("span").textContent = "Added to cart";
            this.submitButton.classList.add("active");

            // Revert back after 2 seconds
            setTimeout(() => {
              this.submitButton.querySelector("span").textContent = originalText;
              this.submitButton.classList.remove("active");
            }, 1000);
          }

        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(this.errorMessageWrapper.closest('.qty_addtocart--wrapper')) this.errorMessageWrapper.closest('.qty_addtocart--wrapper').classList.remove('quantity__error');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      
      if (errorMessage) {
       if(this.errorMessageWrapper.closest('.qty_addtocart--wrapper')) this.errorMessageWrapper.closest('.qty_addtocart--wrapper').classList.add('quantity__error')
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

bisTextUpdate();
function bisTextUpdate() {
  var buttons = document.querySelectorAll("#BIS_trigger");
    if (buttons.length > 0) {
      if(document.querySelector("[data-bis-text]")){
        let text = document.querySelector("[data-bis-text]").getAttribute("data-bis-text");
        buttons.forEach(button => {
          button.textContent = text;
        });
      }
      return 0;
    } else {
      setTimeout(function() {
          bisTextUpdate()
      }, 300)
    }
}
